import React from 'react';
import { MessageSquare, Mail } from 'lucide-react';

interface ChannelTogglesProps {
  smsEnabled?: boolean;
  emailEnabled?: boolean;
  onSmsChange: (enabled: boolean) => void;
  onEmailChange: (enabled: boolean) => void;
  disabled?: boolean;
}

const ChannelToggles: React.FC<ChannelTogglesProps> = ({
  smsEnabled = false,
  emailEnabled = false,
  onSmsChange,
  onEmailChange,
  disabled = false,
}) => {
  return (
    <div className="flex items-center gap-5">
      {/* SMS Switch */}
      <button
        type="button"
        disabled={disabled}
        onClick={() => onSmsChange(!smsEnabled)}
        className={`group flex items-center gap-2 text-xs font-medium transition-colors cursor-pointer select-none focus:outline-none rounded-md ${
          disabled ? 'opacity-50 cursor-not-allowed' : ''
        }`}
      >
        <span
          className={`relative inline-flex items-center h-5 w-8 flex-shrink-0 rounded-full transition-colors duration-200 ease-in-out ${
            smsEnabled ? 'bg-blue-600' : 'bg-gray-300 group-hover:bg-gray-400'
          }`}
        >
          <span
            className={`inline-block h-3.5 w-3.5 rounded-full bg-white shadow-sm transform transition-transform duration-200 ease-in-out ${
              smsEnabled ? 'translate-x-3.5' : 'translate-x-1'
            }`}
          />
        </span>
        <div className="flex items-center gap-1.5 transition-colors">
          <MessageSquare
            className={`w-3.5 h-3.5 transition-colors ${
              smsEnabled ? 'text-blue-600' : 'text-gray-400 group-hover:text-gray-600'
            }`}
          />
          <span
            className={`transition-colors ${
              smsEnabled ? 'text-gray-900 font-semibold' : 'text-gray-600 group-hover:text-gray-800'
            }`}
          >
            SMS
          </span>
        </div>
      </button>

      {/* Email Switch */}
      <button
        type="button"
        disabled={disabled}
        onClick={() => onEmailChange(!emailEnabled)}
        className={`group flex items-center gap-2 text-xs font-medium transition-colors cursor-pointer select-none focus:outline-none rounded-md ${
          disabled ? 'opacity-50 cursor-not-allowed' : ''
        }`}
      >
        <span
          className={`relative inline-flex items-center h-5 w-8 flex-shrink-0 rounded-full transition-colors duration-200 ease-in-out ${
            emailEnabled ? 'bg-blue-600' : 'bg-gray-300 group-hover:bg-gray-400'
          }`}
        >
          <span
            className={`inline-block h-3.5 w-3.5 rounded-full bg-white shadow-sm transform transition-transform duration-200 ease-in-out ${
              emailEnabled ? 'translate-x-3.5' : 'translate-x-1'
            }`}
          />
        </span>
        <div className="flex items-center gap-1.5 transition-colors">
          <Mail
            className={`w-3.5 h-3.5 transition-colors ${
              emailEnabled ? 'text-blue-600' : 'text-gray-400 group-hover:text-gray-600'
            }`}
          />
          <span
            className={`transition-colors ${
              emailEnabled ? 'text-gray-900 font-semibold' : 'text-gray-600 group-hover:text-gray-800'
            }`}
          >
            Email
          </span>
        </div>
      </button>
    </div>
  );
};

export default ChannelToggles;
